import "./Button.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?:
    | "primary"
    | "secondary"
    | "danger"
    | "glory"
    | "outline"
    | "ghost"
    | "warning"
    | "success";
  size?: "sm" | "md" | "lg";
  align?: "left" | "center" | "right";
  isLoading?: boolean;
}

export default function Button({
  children,
  variant = "primary",
  size = "md",
  align = "center",
  isLoading = false,
  disabled,
  className = "",
  ...rest
}: ButtonProps) {
  return (
    <div className={`btn-wrapper align-${align}`}>
      <button
        disabled={disabled || isLoading}
        className={`btn btn-${variant} btn-${size} ${className}`}
        {...rest}
      >
        {isLoading ? <span className="loader with-margin" /> : null}
        {children}
      </button>
    </div>
  );
}
